import moment from "moment";

function parseDateValue(value) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "string" && value.startsWith("0001-01-01")) return null;

  const parsed =
    value instanceof Date || typeof value === "number"
      ? moment(value)
      : moment(
          String(value),
          [moment.ISO_8601, "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD"],
          true
        );

  return parsed.isValid() ? parsed : null;
}

export default {
  methods: {
    frontEndDateFormat(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    backEndDateFormat(date) {
      return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
    },
    formatDateTime(value) {
      const date = parseDateValue(value);
      return date ? date.format("DD MMM YYYY, hh:mm A") : "—";
    },
    formatDateOnly(value) {
      const date = parseDateValue(value);
      return date ? date.format("DD MMM YYYY") : "—";
    },
    sortByDateCreated(items) {
      if (!Array.isArray(items)) return [];

      return items
        .map((item, index) => {
          const date = parseDateValue(item && item.DateCreated);
          return { item, index, timestamp: date ? date.valueOf() : null };
        })
        .sort((a, b) => {
          if (a.timestamp === null && b.timestamp === null) {
            return a.index - b.index;
          }
          if (a.timestamp === null) return 1;
          if (b.timestamp === null) return -1;
          return b.timestamp - a.timestamp || a.index - b.index;
        })
        .map(({ item }) => item);
    },
  },
};
